<script lang="ts">
	export let label: string;
	export let address: string;
	export let tel: string;
</script>

<div>
	<h5 class="text-xl">{label}</h5>
	<p>{address}</p>
	{#if tel}
		<a href="tel:{tel}" class="text-primary mt-2">{tel}</a>
	{/if}
</div>
